"use client"

import { useState, useRef, useEffect } from "react"
import SideDrawer from "../SideDrawer/SideDrawer"
import styles from "./Header.module.css"


import logo from "../../assets/images/estaverde-logo-2.png";
import hero1 from "../../assets/images/hero1.png";
import megaHair from "../../assets/images/mega-hair.jpg";
import megaPlastic from "../../assets/images/mega-nose.jpg";
import hero3 from "../../assets/images/hero3.png";

import wpIcon from "../../assets/images/wp-icon.png";
import instaIcon from "../../assets/images/insta-logo.png";

import ukFlag from "../../assets/images/ukflag.png";
import rusFlag from "../../assets/images/rusflag.png";

export default function Header() {
  
  const [drawerOpen, setDrawerOpen] = useState(false) // Yan menü açık/kapalı durumu
  const [langOpen, setLangOpen] = useState(false) // Dil seçici açık/kapalı durumu
  const [activeMenu, setActiveMenu] = useState(null) // Aktif mega menü indexi
  // Referanslar - Mouse hareketlerini takip etmek için
  const headerRef = useRef(null) // Header elementi referansı
  const megaRef = useRef(null) // Mega menü elementi referansı // Mega menü elementi referansı

  
  const menu = [
    { label: "Dental Treatments", items: ["Hollywood Smile", "Dental Implants", "Root Canal", "Teeth Whitening"] },
    { label: "Hair Transplant", items: ["Autologous Micrograft", "Sapphire FUE Hair Transplant", "DHI Hair Transplant"] },
    { label: "Plastic Surgeries", items: ["Rhinoplasty"] }
  ]

  
  
  const menuImages = {
    "Dental Treatments": hero1,
    "Hair Transplant": megaHair,
    "Plastic Surgeries": megaPlastic,
  }

  
  // Mouse pozisyonunun bir alan içinde olup olmadığını kontrol eden yardımcı fonksiyon
  const isPointInRect = (x, y, rect) => x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom

  
  // Mouse header veya mega menü dışına çıkarsa menüyü kapat
  useEffect(() => {
    const onMove = (e) => {
      if (activeMenu === null) return
      const x = e.clientX
      const y = e.clientY
      const headerEl = headerRef.current
      const megaEl = megaRef.current
      // Mouse header veya mega menü içinde mi kontrol et
      const inHeader = headerEl ? isPointInRect(x, y, headerEl.getBoundingClientRect()) : false
      const inMega = megaEl ? isPointInRect(x, y, megaEl.getBoundingClientRect()) : false
      // Her ikisinin de dışındaysa menüyü kapat
      if (!inHeader && !inMega) {
        setActiveMenu(null)
      }
    }
    window.addEventListener("mousemove", onMove)
    return () => window.removeEventListener("mousemove", onMove)
  }, [activeMenu])

  return (
    <>
      
      <header 
        className={styles.header}
        ref={headerRef}
      >
        <div className={styles.headerGrid}>
          {/* Logo bölümü */}
          <div className="logo">
            <a href="/">
              <img className={styles.logoImg} src={logo} alt="Estaverde Logo" />
            </a>
          </div>

          
          {/* Ana navigasyon menüsü - Dental Treatments hariç diğer menüler gösteriliyor */}
          <nav className={styles.nav} aria-label="Primary">
            {menu.filter(m => m.label !== "Dental Treatments").map((m, i) => (
              <div className={styles.navItem} key={i}>
                <button 
                  className={styles.navBtn} 
                  aria-haspopup="true" 
                  aria-expanded={activeMenu === i}
                  onMouseEnter={() => setActiveMenu(i)} // Mouse üzerine gelince mega menüyü aç
                >
                  {m.label}
                </button>
              </div>
            ))}
          </nav>

          
          {/* Sağ taraftaki eylem butonları (WhatsApp, Instagram, Dil, Menü) */}
          <div className={styles.actions}>
            
            <a
              className={styles.whatsapp}
              href="https://wa.me/905337674950"
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
            >
              <img src={wpIcon} alt="WhatsApp" className={styles.wpIcon} />
              <span className={styles.wpText}>Support <span id={styles.lineText}>Line</span></span>
            </a>

            
            
            <a
              className={styles.instagram}
              href="https://instagram.com/estaverde_clinic"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <img src={instaIcon} alt="Instagram" className={styles.instaIcon} />
              <span className={styles.instaUsername}>EstaVerde</span>
            </a>

            {/* Dil seçici */}
            <div className={styles.langWrap}>
              <button className={styles.langBtn} onClick={() => setLangOpen((s) => !s)} aria-haspopup="listbox">
                <img src={ukFlag} alt="UK" className={styles.flagIcon} /> EN
              </button>
              {/* Dil seçenekleri dropdown */}
              {langOpen && (
                <ul className={styles.langList} role="listbox" onMouseLeave={() => setLangOpen(false)}>
                  <li role="option">
                    <button className={styles.langOpt}>
                      <img src={ukFlag} alt="UK" className={styles.flagIcon} /> EN
                    </button>
                  </li>
                  <li role="option">
                    <button className={styles.langOpt}>
                      <img src={rusFlag} alt="RU" className={styles.flagIcon} /> RU
                    </button>
                  </li>
                </ul>
              )}
            </div>

            {/* Mobil menü butonu (hamburger) */}
            <button className={styles.menuBtn} onClick={() => setDrawerOpen(true)} aria-label="Open menu">
              ☰
            </button>
          </div>
        </div>
      </header>

      {/* Mega menü */}
      {/* Aktif menü varsa göster */}
      {activeMenu !== null && (
        <div 
          className={styles.megaMenu}
          ref={megaRef}
          onMouseEnter={() => setActiveMenu(activeMenu)} // Mouse mega menünün üzerindeyken menüyü açık tut
          onMouseLeave={() => setActiveMenu(null)} // Mouse mega menüden ayrılınca kapat
        >
          <div className={styles.megaLayout}>
            
            {/* Sol taraf - Menü linkleri ve CTA butonu */}
            <div className={styles.megaLeft}>
              <nav className={styles.megaList}>
                {/* Aktif menüdeki alt öğeleri listele ve her birine uygun URL ata */}
                {menu.filter(m => m.label !== "Dental Treatments")[activeMenu]?.items.map((item, index) => {
                  let href = "#"
                  // Her tedavi için ilgili sayfaya yönlendirme
                  if (item === "Autologous Micrograft") href = "/autologous-micrograft"
                  if (item === "Sapphire FUE Hair Transplant") href = "/sapphire-fue-hair-transplant"
                  if (item === "DHI Hair Transplant") href = "/dhi-hair-transplant"
                  if (item === "Rhinoplasty") href = "/rhinoplasty"
                  return (
                    <a key={index} href={href} className={styles.megaItem}>
                      {item}
                    </a>
                  )
                })}
              </nav>
              {/* Sonuçları görüntüle CTA butonu */}
              <a href="/results" className={styles.megaCta}>View Results</a>
            </div>
            
            {/* Sağ taraf - Menü görseli */}
            <div className={styles.megaRight}>
              {/* Aktif menüye uygun görseli göster */}
              <img src={menuImages[menu.filter(m => m.label !== "Dental Treatments")[activeMenu]?.label] || hero1} alt={menu.filter(m => m.label !== "Dental Treatments")[activeMenu]?.label || "Menu"} />
            </div>
          </div>
        </div>
      )}

      {/* Yan çekmece menü (mobil menü) */}
      <SideDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  )
}
